import { render, staticRenderFns } from "./SelfieSettingsSection.vue?vue&type=template&id=f8f55e28"
import script from "./SelfieSettingsSection.vue?vue&type=script&lang=js"
export * from "./SelfieSettingsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports